/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTaskQuery } from '../../models/get-project-task-query';
import { GetProjectTaskQueryResult } from '../../models/get-project-task-query-result';

export interface ApiProjectTaskGetProjectTaskPost$Plain$Params {
      body?: GetProjectTaskQuery
}

export function apiProjectTaskGetProjectTaskPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTaskGetProjectTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskGetProjectTaskPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTaskQueryResult>;
    })
  );
}

apiProjectTaskGetProjectTaskPost$Plain.PATH = '/api/ProjectTask/GetProjectTask';
